import React from 'react'
import classnames from 'classnames'
import { loadBetRecommendations } from '../../actions'
import { connectPagination } from '../../decorators'
import { Schemas } from '../../middleware/api'
import { TableList } from '../Generic'
import { recommendationsColumns } from '../../settings'
import moment from 'moment'


class RecommendationsList extends React.Component {
  render() {
    const { stickyStyle, stickyTopOffset, columns } = this.props;
    const hits = this.props.hits || [];

    return (
      <TableList
        {...this.props}
        rowClassName={({ rowData, index }) => (
          classnames('table-row', {'table-row--is-hit': hits[rowData.event_id]})
        )}
        stickyStyle={stickyStyle}
        stickyTopOffset={stickyTopOffset}
        columns={columns || recommendationsColumns} />
    )
  }
}

export default connectPagination({
  entitykey: 'betRecommendations',
  loadItems: loadBetRecommendations,
  itemSchema: Schemas.BET_RECOMMENDATION,
  keygen: ({state, ownProps}) => ownProps.keygen({state, ownProps}),
  getQueryParams: ({state, ownProps}) => {
    const ret = {
      user_id: ownProps.playerId,
      fields: 'confidence,event_id,country,sport,description,participants,start_timestamp,tournament',
      limit: 25,
      num_context_events: ownProps.numContextEvents || 2,
      coupon_index: ownProps.couponIndex || 0,
      recommendations_type: ownProps.recommendationsType || 'personalized',
    }

    // When requesting recommendations for the current date we let the API return default time range. 
    // Only when requesting recommendations for a specific day in the past we add time range params.
    if (ownProps.afterDate && moment(ownProps.afterDate).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD')) {
      ret.after_date = ownProps.afterDate;
      ret.before_date = ownProps.beforeDate;
    }
    
    return ret;
  },
  title: 'Player Recommendations Pagination',
})(RecommendationsList)


// WEBPACK FOOTER //
// ./src/components/Players/RecommendationsList.js